import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ImportWspManager } from '../../../import-export/service/import-wsp.manager';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SharedModule } from '@shared/shared.module';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UserModel } from '@user/model/user.model';
import { ProServeProjectImportManager } from '../../../import-export/service/pro-serve-project-import.manager';
import { UserPermissionService } from '@user/service/user-permission.service';
import { SvgIconComponent } from '@shared/svg-icon/svg-icon.component';
import { ActionLogDirective } from '@user/service/logging/actionlog.directive';
import { TileButtonComponent } from '@shared/tile-button/tile-button.component';
import { CaeImportService } from '@project/cae/cae-import.service';
import { CsvImportService } from '@project/csv/csv-import.service';

@Component({
  templateUrl: 'import-choice-dialog.component.html',
  selector: "app-import-choice-dialog",
  styleUrls: ["./import-choice-dialog.component.scss", '../../../../../../../scss/shared-component-styles/hero.scss'],
  imports: [
    TranslateModule,
    SharedModule,
    ActionLogDirective,
    SvgIconComponent,
    TileButtonComponent,
  ],
})
export class ImportChoiceDialogComponent implements OnInit {

  public enabledEntries: Map<'localBackup' | 'cae' | 'proserve' | 'csv', boolean> = new Map();

  public isLoggedIn!: boolean;

  constructor(
    private importWspManager: ImportWspManager,
    protected bsModalRef: BsModalRef,
    router: Router,
    private userModel: UserModel,
    private proServeProjectImportManager: ProServeProjectImportManager,
    private userPermissionService: UserPermissionService,
    private caeImportService: CaeImportService,
    private csvImportService: CsvImportService,
  ) {
    router.events.pipe(takeUntilDestroyed(), filter(event => event instanceof NavigationStart))
      .subscribe(() => this.bsModalRef.hide())
  }

  ngOnInit() {
    const isConstruction = this.userModel.isConstruction;

    this.enabledEntries = new Map([
      ["localBackup", this.userPermissionService.isLocalBackupVisible() && !isConstruction],
      ["proserve", this.userPermissionService.isProServeImportVisible() && !isConstruction],
      ["cae", this.userPermissionService.isCAEEnabled() && this.userPermissionService.isCAEVisible() && !isConstruction],
      [ 'csv', this.isLoggedIn ],
    ]);
  }

  public async actionWithWsp(): Promise<void> {
    await this.importWspManager.importWspProject();
  }

  public async actionWithProServe(): Promise<void> {
    await this.proServeProjectImportManager.importProServeProject({navigateToConfigurator: true});
  }

  public async actionWithCae(): Promise<void> {
    await this.caeImportService.startCaeImport();
  }

  public async actionWithCsv(): Promise<void> {
    await this.csvImportService.startCsvImport();
  }
}
